import {
  createRouter,
  createWebHistory,
} from 'vue-router';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [],
  scrollBehavior(to, from, savedPosition) {
    return { top: savedPosition?.top || 0 };
  },
});
